var _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_136",
    "data-name": "Group 136",
    xmlns: "http://www.w3.org/2000/svg",
    width: 216.775,
    height: 94.02,
    viewBox: "0 0 216.775 94.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M84.409,41.828h4.22c3.555,0,6.012,2.439,6.012,5.624v.034a5.664,5.664,0,0,1-6.012,5.658h-4.22Zm4.22,9.5a3.69,3.69,0,0,0,3.929-3.816v-.031a3.714,3.714,0,0,0-3.929-3.848H86.4v7.694Z",
    transform: "translate(-34.051 -41.633)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 1.99,
    height: 11.316,
    transform: "translate(66.507 0.195)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M124.229,51.381l1.2-1.421A5.213,5.213,0,0,0,129,51.428c1.229,0,2.007-.563,2.007-1.421v-.032c0-.809-.454-1.245-2.555-1.729-2.409-.584-3.764-1.294-3.764-3.379v-.033c0-1.94,1.614-3.282,3.86-3.282a6.278,6.278,0,0,1,4.106,1.421l-1.066,1.5a5.127,5.127,0,0,0-3.07-1.162c-1.165,0-1.843.6-1.843,1.34v.034c0,.872.516,1.26,2.685,1.776,2.39.582,3.634,1.44,3.634,3.316v.03c0,2.12-1.664,3.379-4.039,3.379a6.967,6.967,0,0,1-4.722-1.811",
    transform: "translate(-50.122 -41.521)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M150.361,43.671H146.77V41.831h9.183v1.841h-3.586v9.471h-2.007Z",
    transform: "translate(-59.215 -41.635)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M181,53.144h-1.991V49.2h-2.488l-2.781,3.944H171.4l3.055-4.287a3.39,3.39,0,0,1-2.7-3.424V45.4a3.425,3.425,0,0,1,.936-2.443,4.571,4.571,0,0,1,3.266-1.129H181Zm-1.991-5.707v-3.8h-2.891c-1.472,0-2.347.663-2.347,1.875v.032c0,1.147.905,1.891,2.329,1.891Z",
    transform: "translate(-69.149 -41.633)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 1.987,
    height: 11.316,
    transform: "translate(117.419 0.195)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M213.11,43.671h-3.588V41.831H218.7v1.841h-3.589v9.471h-2Z",
    transform: "translate(-84.532 -41.635)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M232.258,47.382v-.031a5.915,5.915,0,0,1,11.83-.033v.033a5.915,5.915,0,0,1-11.83.031m9.746,0v-.031a3.878,3.878,0,0,0-3.846-4.028,3.826,3.826,0,0,0-3.817,3.995v.033a3.876,3.876,0,0,0,3.847,4.022A3.823,3.823,0,0,0,242,47.382",
    transform: "translate(-93.683 -41.498)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M66.806,100.368l-17.838,43.75-6.141,15.57H54.776l25.239-59.32Z",
    transform: "translate(-17.584 -65.668)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M13.546,100.368H0l18.616,43.75H31.384l-7.825-19.1Z",
    transform: "translate(0 -65.668)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M126.4,149.558a7.233,7.233,0,0,1,0-14.466h18.966l-4.477-10.13h-11.4L122.283,110.5h12.73l-4.474-10.129H105.921L119,126.615a17.364,17.364,0,0,0,7.4,33.07h30.356l-4.477-10.128Z",
    transform: "translate(-42.541 -65.668)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M270.863,159.686,288.7,115.933l6.141-15.566H282.893l-25.243,59.319Z",
    transform: "translate(-103.307 -65.668)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M328.165,170.529h13.543L323.09,126.776H310.326l7.825,19.1Z",
    transform: "translate(-124.933 -76.511)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M201.767,110.5a7.233,7.233,0,0,1,0,14.466H182.8l4.475,10.129h11.4l7.209,14.467H193.149l4.477,10.127h24.617l-13.075-26.248a17.364,17.364,0,0,0-7.4-33.07H171.412l4.479,10.129Z",
    transform: "translate(-68.845 -65.669)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/logo-proyecto.b4a094da11b53d73e07ea1ce7e964fc0.svg";
export { ForwardRef as ReactComponent };